export const isFullStatic = false
export const staticPath = "/home/ubuntu/FirstFocusAgents/CVL-NUC-AGENT-1/_work/7/a/NuxtApp/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"